// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"H_thecomp__39znn","swiperTool":"H_swiperTool__14Ljo"};